import { user } from './Utils';

const API_BASE_URL = process.env.REACT_APP_API_SERVER;

async function fetchAPI(path, options = {}) {
  let queryString = '';
  if (options.params) {
    const searchParams = new URLSearchParams(options.params);
    queryString = `?${searchParams.toString()}`;
    delete options.params;
  }

  const url = `${API_BASE_URL}${path}${queryString}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (response.status === 401) {
    localStorage.removeItem('auth');
  }

  if (!response.ok) {
    throw new Error(`API call failed: ${url}, status: ${response.status}`);
  }

  return response.json();
}

function userAuth(){
  return { 'Authorization': `Bearer ${user().token}`};
}

export const apiService = {
  // users and profile
  async get() { return fetchAPI('/me', { method: 'GET', headers: userAuth()});},

};